import React, { ButtonHTMLAttributes } from 'react';
import styles from './Button.module.css';

const LinkLikeButton: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ children, ...restProps }) => {
    return (
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        <button type="button" className={styles.linkLikeButton} {...restProps}>
            {children}
        </button>
    );
};

export default LinkLikeButton;
